"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogActions = exports.DialogContentText = exports.DialogContent = exports.DialogTitle = exports.Dialog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
exports.Dialog = react_1.forwardRef(function Dialog(props, ref) {
    return jsx_runtime_1.jsx(core_1.Dialog, __assign({}, props, { ref: ref }), void 0);
});
exports.DialogTitle = react_1.forwardRef(function DialogTitle(props, ref) {
    return jsx_runtime_1.jsx(core_1.DialogTitle, __assign({}, props, { ref: ref }), void 0);
});
exports.DialogContent = react_1.forwardRef(function DialogContent(props, ref) {
    return jsx_runtime_1.jsx(core_1.DialogContent, __assign({}, props, { ref: ref }), void 0);
});
exports.DialogContentText = react_1.forwardRef(function DialogContentText(props, ref) {
    return jsx_runtime_1.jsx(core_1.DialogContentText, __assign({}, props, { ref: ref }), void 0);
});
exports.DialogActions = react_1.forwardRef(function DialogActions(props, ref) {
    return jsx_runtime_1.jsx(core_1.DialogActions, __assign({}, props, { ref: ref }), void 0);
});
//# sourceMappingURL=Dialog.js.map